import { ImagePublicFileId } from '../image/image-public-file-id'
import React from 'react'
import { Col } from 'react-bootstrap'
import { Challenge } from 'src/dao/core-dao'
import { cn } from 'src/lib/utils'

interface ProfileYourAwardsCardProps {
  challenge: Challenge
  progress?: number
  isStarted?: boolean
  isCompleted?: boolean
}

export const ProfileYourAwardsCard = ({
  challenge,
  progress,
  isStarted = false,
  isCompleted = false,
}: ProfileYourAwardsCardProps): React.ReactElement => {
  return (
    <div className={cn('p-5 px-[15px] rounded-md border border-bright-grey h-[255px] flex flex-col justify-between')}>
      <div className={`${!isCompleted && 'opacity-40'}`}>
        <ImagePublicFileId
          fileId={challenge.imagePublicFileId}
          className={cn('block w-full max-w-[140px] h-full max-h-[120px] object-contain mx-auto')}
        />
      </div>
      <div>
        <h4
          className={cn(
            'text-center text-base font-semibold font-roboto-condensed-medium leading-[22px] capitalize',
            isCompleted ? 'text-primary-gray' : 'text-ivory',
          )}
        >
          {challenge?.title}
        </h4>
        {isStarted && (
          <h5
            className={cn(
              'text-center text-base font-semibold font-roboto-condensed-medium leading-[22px] capitalize',
              isCompleted ? 'text-primary-gray' : 'text-ivory',
            )}
          >
            {progress}/{challenge.criteria?.goal}
          </h5>
        )}
        {isCompleted && (
          <h5
            className={cn(
              'text-center text-base font-semibold font-roboto-condensed-medium leading-[22px] capitalize',
              isCompleted ? 'text-primary-gray' : 'text-ivory',
            )}
          >
            {challenge.criteria?.goal}/{challenge.criteria?.goal}
          </h5>
        )}
      </div>
    </div>
  )
}
